import { Outlet } from "react-router-dom";
import { LensRefreshAlertProvider } from "contexts/LensRefreshAlertContext";
import { useAppSelector } from "redux/hooks";
import { selectClientLens } from "redux/slices/clientLens";

export const LensRoute = () => {
  const lens = useAppSelector(selectClientLens).lens;

  return (
    <LensRefreshAlertProvider lens={lens}>
      <Outlet />
    </LensRefreshAlertProvider>
  );
};
